/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_BlackoutListDTO } from '../models/PagedResultDto_BlackoutListDTO';
import type { Wealthlane_CustomerService_Dtos_Blackout_CreateUpdateBlackoutDto } from '../models/Wealthlane_CustomerService_Dtos_Blackout_CreateUpdateBlackoutDto';
import type { Wealthlane_CustomerService_Dtos_Blackout_GetStatusDTO } from '../models/Wealthlane_CustomerService_Dtos_Blackout_GetStatusDTO';
import type { Wealthlane_CustomerService_Dtos_Response_ResponseDto } from '../models/Wealthlane_CustomerService_Dtos_Response_ResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BlackoutService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_Blackout_GetStatusDTO OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppBlackoutBlackoutEligiblityStatuses(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_Blackout_GetStatusDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/blackout/blackout-eligiblity-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_CustomerService_Dtos_Blackout_CreateUpdateBlackoutDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppBlackoutBlackoutById(
id: string,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Blackout_CreateUpdateBlackoutDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/blackout/blackout-by-id/{Id}',
            path: {
                'Id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param eligibleForIds 
     * @param startDate 
     * @param endDate 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_BlackoutListDTO OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppBlackoutBlackoutList(
eligibleForIds?: Array<number>,
startDate?: string,
endDate?: string,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_BlackoutListDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/blackout/blackout-list',
            query: {
                'EligibleForIds': eligibleForIds,
                'StartDate': startDate,
                'EndDate': endDate,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppBlackoutTest1(): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/blackout/test1',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppBlackoutBlackout(
requestBody?: Wealthlane_CustomerService_Dtos_Blackout_CreateUpdateBlackoutDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/blackout/blackout',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppBlackoutBlackout(
requestBody?: Wealthlane_CustomerService_Dtos_Blackout_CreateUpdateBlackoutDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/blackout/blackout',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_CustomerService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static deleteApiCustomerApiAppBlackoutBlackout(
id: string,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/customer/api/app/blackout/blackout/{Id}',
            path: {
                'Id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
